import ChatView from '@/pages/chat/ChatView';
import Knowledge from '@/pages/knowledge';
import { IMenu } from '@/typings';

export default [
	{
		id: 'knowledge',
		url: 'knowledge',
		name: '知识库',
		icon: 'home',
		component: Knowledge,
	},
	{
		id: 'chatDetail',
		url: 'chat/:id',
		name: '会话记录',
		icon: 'home',
		hidden: true,
		component: ChatView,
	},
	// {
	// 	id: 'history',
	// 	url: 'history',
	// 	name: '历史记录',
	// 	icon: 'home',
	// },
] as IMenu[];
